import { useTranslation } from "react-i18next"
import { Button, Flex } from "@chakra-ui/react"

import { ShowRoomBranding } from "../../../recoil/atoms/shows/types"
import { useRecoilValue } from "recoil"
import { viewSelector } from "../../../recoil/atoms/view"
import { Views } from "../../../constants"

type ShowCardHoverOverlayProps = {
  branding: ShowRoomBranding
  openShow: () => void
  openShowInNewTab: () => void
  isRoomloading: boolean
  isCurrentRoomLoading: boolean
}

const ShowCardHoverOverlay = ({
  branding,
  openShow,
  openShowInNewTab,
  isRoomloading,
  isCurrentRoomLoading
}: ShowCardHoverOverlayProps) => {
  const { t } = useTranslation()
  const view = useRecoilValue(viewSelector)

  return (
    <Flex
      position="absolute"
      width="full"
      height="full"
      zIndex="banner"
      backgroundColor="rgba(51,51,51,0.8)"
      justify="center"
      align="center"
      userSelect="none"
      direction="column"
    >
      <Button
        isLoading={isCurrentRoomLoading}
        disabled={isRoomloading}
        loadingText={t("Joining...")}
        bg={branding?.joinButtonBackgroundColor ?? "#1AC541"}
        border={
          branding?.joinButtonBorderColor
            ? `1px solid ${
                branding?.joinButtonBorderColor
                  ? branding.joinButtonBorderColor
                  : "transparent"
              }`
            : "0px"
        }
        textColor={branding?.JoinPageButtonTextColor ?? "#FFFFFF"}
        _hover={{
          backgroundColor:
            branding?.joinButtonMouseoverBackgroundColor ?? "#24A840",
          textColor: branding?.JoinPageButtonMouseoverTextColor ?? "#FFFFFF"
        }}
        _disabled={{ opacity: 0.38 }}
        width="156px"
        _focus={{}}
        _active={{}}
        onClick={openShow}
      >
        {t("Watch here")}
      </Button>

      {view === Views.MEETING_ROOM && (
        <Button
          bg={branding?.joinButtonBackgroundColor ?? "#1AC541"}
          border={
            branding?.joinButtonBorderColor
              ? `1px solid ${
                  branding?.joinButtonBorderColor
                    ? branding.joinButtonBorderColor
                    : "transparent"
                }`
              : "0px"
          }
          textColor={branding?.JoinPageButtonTextColor ?? "#FFFFFF"}
          _hover={{
            backgroundColor:
              branding?.joinButtonMouseoverBackgroundColor ?? "#24A840",
            textColor: branding?.JoinPageButtonMouseoverTextColor ?? "#FFFFFF"
          }}
          width="156px"
          _focus={{}}
          _active={{}}
          onClick={openShowInNewTab}
          margin={2}
          _disabled={{ opacity: 0.38 }}
          disabled={isRoomloading}
        >
          {t("Watch in new tab")}
        </Button>
      )}
    </Flex>
  )
}

export default ShowCardHoverOverlay
